<script>
export default {
  props: {
    progress: {
      type: Number,
      required: true
    }
  }
};
</script>

<template>
  <div class="progress-bar">
    <div class="progress-bar-total" />

    <div class="progress-bar-elapsed" :style="`width: ${progress}%`" />
  </div>
</template>

<style scoped>
.progress-bar {
  width: 100%;
  height: 4px;
  position: relative;
}

.progress-bar-total,
.progress-bar-elapsed {
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: #af006b;
  border-radius: 2px;
}

.progress-bar-total {
  opacity: 0.25;
}
</style>



// WEBPACK FOOTER //
// src/components/_base/ProgressBar.vue